/**
 * Day 6 and Day 7 decks are published twice. Iteration 2 (AWS_REFRESH) skips
 * Hydros ingestion and only re-runs the presentation sync with the AWS flag.
 * Only these cycles expose the publish iteration selector.
 */
export const isPublishIterationApplicable = (deckCycle?: string): boolean =>
  /^day\s*[67]$/i.test((deckCycle ?? '').trim());
